import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';
import { ApiService } from 'src/app/services/api/api.service';
import { InfozonemodalComponent } from 'src/app/components/infozonemodal/infozonemodal.component';

@Component({
    selector: 'app-smblockinfozone',
    templateUrl: './smblockinfozone.component.html',
    styleUrls: ['./smblockinfozone.component.scss'],
    standalone: false
})
export class SmblockinfozoneComponent implements OnInit {
  @Input() b: any;
  public basepath = '';

  private api = inject(ApiService);

  constructor(
    public data: DataService,
    public router: Router,
    public http: HttpClient,
    public alertController: AlertController,
    public route: ActivatedRoute,
    public modalController: ModalController) { }

  ngOnInit() { 
      this.basepath = this.api.getMediaBase();
  }
  
  async selectInfozone(infozone) {
    let that = this
    const modal = await this.modalController.create({
      component: InfozonemodalComponent,
      animated: false,
      htmlAttributes: { 'aria-label': 'Info: ' + (infozone?.title || '') },
      componentProps: {
        infozone: infozone,
        basepath: that.api.getMediaBase()
      }
    });

    let payload = {
      token: this.data.token,
      title: 'Open infozone ' + infozone.id,
      pathway_id: that.data.pathway ? that.data.pathway.id : '',
      condition: (that.data.pathway && that.data.pathway.condition) ? that.data.pathway.condition.id : ''
    };
    void this.data.apiPost('userappnav', payload);
    return await modal.present();
  }

  infozonethumbpath(infozone){
    return encodeURI(this.api.mediaUrl(infozone.thumb));
  }

  mediaUrl(path: string): string {
    return this.api.mediaUrl(path);
  }

  safeURL(item) {
    return encodeURI(item);
  }
}